const schema = {
    type: {
        id: 'type',
        label: '',
        required: true,
        disabled: false,
        type: 'radio',
        value: '1',
        lookup: 'Contrato(s)',
        options: [
            {
                codigo: '1',
                nome: 'Por Número de contrato',
            },
            {
                codigo: '2',
                nome: 'Por Estado e Município',
            },
        ],
    },
    contractNumber: {
        id: 'contractNumber',
        label: 'Nº de contrato da empresa',
        required: true,
        type: 'text',
    },
    healthPlan: {
        id: 'healthPlan',
        label: 'Plano de saúde',
        required: true,
        type: 'select',
        requiredMessage: 'Selecione o plano de saúde',
    },
    state: {
        id: 'state',
        label: 'Estado de atendimento',
        required: true,
        placeholder: 'Selecione',
        type: 'select',
        options: [],
    },
    city: {
        id: 'city',
        label: 'Município de atendimento',
        required: true,
        type: 'select',
        options: [],
    },
}

export default schema;